import {gql, useLazyQuery} from "@apollo/client";

const GET_DATA = gql`
    query PortalDivision ($divisionSlug: String!) {
        portalDivision(divisionSlug: $divisionSlug){
            id
            slug
            name
            organization{
                id
                name
            }
            sport{
                key
                name
            }
            isOpen
            activeSeason{
                id
                slug
                name
                registrationStartDate
                registrationEndDate
                startDate
                endDate
                state
                teams{
                    teamId
                    teamName
                    team{
                        logoUrl
                        players{
                            id
                            playerId
                            fullName
                            shirtNumber
                            status
                            position{
                                key
                                name
                            }
                        }
                        coaches{
                            id
                            playerId
                            fullName
                        }
                        slug
                    }
                }
                gamesCount
                playersCount
                stages{
                    id
                    name
                }
            }
            seasons{
                id
                slug
                name
                registrationStartDate
                registrationEndDate
                startDate
                endDate
                state
                teams{
                    teamId
                    teamName
                    team{
                        logoUrl
                        players{
                            id
                            playerId
                            fullName
                            shirtNumber
                            status
                            position{
                                key
                                name
                            }
                        }
                        coaches{
                            id
                            playerId
                            fullName
                        }
                        slug
                    }
                }
                stages{
                    id
                    name
                }
                playersCount
            }
        }
    }

`;

export default function GetPublicDivisionDetail() {
    return useLazyQuery(GET_DATA);
};
